import * as React from 'react';



export default class CombinedView extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="Group-4" transform="translate(1.000000, 1.000000)">
            <g id="Page-1">
                <path d="M6.45486933,1.48215467 L14.1848689,1.48215467" id="Stroke-1" strokeLinecap="round"></path>
                <path d="M0.426496,1.48215467 L1.895936,1.48215467" id="Stroke-3" strokeLinecap="round"></path>
                <path d="M6.45486933,7.36631467 L14.1848689,7.36631467" id="Stroke-5" strokeLinecap="round"></path>
                <path d="M0.426496,7.36631467 L1.895936,7.36631467" id="Stroke-7" strokeLinecap="round"></path>
                <path d="M6.45486933,13.25056 L14.1848689,13.25056" id="Stroke-9" strokeLinecap="round"></path>
                <path d="M0.426496,13.25056 L1.895936,13.25056" id="Stroke-11" strokeLinecap="round"></path>
                <path className="strokeColor" stroke="currentColor" d="M4.12612267,1.48215467 C4.12612267,2.06498133 3.653376,2.537728 3.07054933,2.537728 C2.48772267,2.537728 2.014976,2.06498133 2.014976,1.48215467 C2.014976,0.899328 2.48772267,0.426581333 3.07054933,0.426581333 C3.653376,0.426581333 4.12612267,0.899328 4.12612267,1.48215467 Z" id="Stroke-13"></path>
                <path className="strokeColor" stroke="currentColor" d="M4.12612267,7.36631467 C4.12612267,7.94914133 3.653376,8.42103467 3.07054933,8.42103467 C2.48772267,8.42103467 2.014976,7.94914133 2.014976,7.36631467 C2.014976,6.783488 2.48772267,6.31074133 3.07054933,6.31074133 C3.653376,6.31074133 4.12612267,6.783488 4.12612267,7.36631467 Z" id="Stroke-15"></path>
                <path className="strokeColor" stroke="currentColor" d="M4.12612267,13.25056 C4.12612267,13.8333867 3.653376,14.30528 3.07054933,14.30528 C2.48772267,14.30528 2.014976,13.8333867 2.014976,13.25056 C2.014976,12.66688 2.48772267,12.1949867 3.07054933,12.1949867 C3.653376,12.1949867 4.12612267,12.66688 4.12612267,13.25056 Z" id="Stroke-17"></path>
            </g>
        </g>
      </svg>
    )
  }
}
